import script from "./CommentsModeration.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommentsModeration.vue?vue&type=script&lang=ts&setup=true"

import "./CommentsModeration.vue?vue&type=style&index=0&id=0c71aa26&lang=sass"

const __exports__ = script;

export default __exports__